import { DEFAULT_PAGE_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import { fetchPost, fetchGet, objectify } from './../utils'
import moment from 'moment';

export const search = (query) => {
  const { CustomerId, filters, Page, Sort, SortDirection, BatchSize = DEFAULT_PAGE_SIZE } = query

  const From = filters && filters.FromDate && moment(filters.FromDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
  const To = filters && filters.ToDate && moment(filters.ToDate, 'DD/MM/YYYY').format('YYYY-MM-DD');

  return fetchPost(
    `/CustomerEnquiry/Customer/${CustomerId}/Transactions`,
    filters &&
    {
      ...filters,
      FromDate: From == "" ? null : From,
      ToDate: To == "" ? null : To,
      TransactionOption: filters.TransactionOption == '0' ? null : filters.TransactionOption,
      TransactionType: filters.TransactionType == '0' ? null : filters.TransactionType
    },
    { BatchPage: Page, Sort: Sort && SortDirection && `${Sort}:${SortDirection}`, BatchSize }
  )
    .then((result) => {
      if (result) {
        if (result.Transactions) {
          return {
            records: result.Transactions.map((val) =>
              Object.assign({}, objectify(val))),
            nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
            currPage: result.BatchInformation && result.BatchInformation.BatchPage,
          }
        }
        else {
          return result
        }
      }
    })
}


export const getDetails = (query) => {
  const { TransactionId } = query;
  const respType = 'Inline';
  return fetchGet(`/CustomerEnquiry/Transactions/${TransactionId}/Details`, null, respType)
    .then((result) => result ? { inlineObject: objectify(result.TransactionDetail, null, 'Inline'), schema: result.TransactionDetail } : null)
}

export const getSummary = (query) => {
  const { TransactionId } = query;
  const respType = 'Inline';
  return fetchGet(`/CustomerEnquiry/Transactions/${TransactionId}/Summary`, null, respType)
    .then((result) => result && result.TransactionSummary);
}
